export default {
    name : 'taxonomy',

    init()
    {
        const el = document.getElementById('taxonomy');
        if (el) {
            const vueData = (typeof window['taxonomy'] === 'object') ? window['taxonomy'] : null;
            if (el && vueData && vueData.items.length===0) {
                this.run(vueData);
            }

            window.onpageshow = function(event) {
                if (event.persisted) {
                    window['taxonomy'].restoreScrollPosition();
                }
            };
        }
    },

    run (vueData)
    {
        window['taxonomy'] = new Vue({
            el: '#taxonomy',

            delimiters: ['@{','}'],

            data : vueData,

            filters: {
                nok (value, decimal_sep)
                {
                    if (!value) {
                        return null;
                    }

                    value = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                    return value + decimal_sep;
                }
            },

            computed :
            {
                busyClass ()
                {
                    return (this.isBusy) ? 'busy' : "";
                }
            },

            methods:
            {
                showSubMenu(subTerm)
                {
                    return (subTerm.subTerms && (subTerm.term_id == this.term_id
                            || subTerm.term_id == this.parentTermId // if term is current term
                            || subTerm.term_id == this.ancestorId)
                        );
                },

                toggleBusy()
                {
                    this.isBusy = !this.isBusy;
                },

                hasFeaturedTerm(item)
                {
                    if (typeof item === 'undefined') {
                        return false;
                    }

                    return (typeof item.firstFeaturedTerm === 'object' && item.firstFeaturedTerm !== null) ? true : false;
                },

                isChecked (is, required)
                {
                    return (is === required) ? 'active' : '';
                },

                initWindowScroll()
                {
                    if (this.isInViewport(document.getElementById("js_showMore"))) {
                        this.updatePublicItems();
                    }

                    this.updateScrollPosition();
                },

                isInViewport(el)
                {
                    if (typeof el === 'object' && el) {
                        const rect = el.getBoundingClientRect();

                        return (
                            rect.top >= 0 &&
                            rect.left >= 0 &&
                            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                     );
                    } else {
                        return false;
                    }
                },

                orderByChanged( close )
                {
                    this.setActiveFilters();
                    this.sortItems();


                    if (typeof close === 'boolean' && close === true) {
                        this.toggleMobileWidget('js_theOrders');
                    }
                },

                subTermChanged()
                {
                    if (this.subTermId) {
                        const subTerm = this.findTermById(this.subTermId);
                        if (subTerm) {
                            window.location.href = subTerm.link;
                        }
                    }
                },

                findTermById ( termId )
                {
                    return this.subTermsMobile.find(term => term.term_id == termId);
                },

                colorsChanged ()
                {
                    this.setActiveFilters();
                    this.filterItems();
                    this.prepareAnalytics();
                },

                categoryChanged(event)
                {
                    this.colors = this.materials = [];

                    if (event.target.dataset.anc=='0') {
                        // reset other main terms on term change
                        if (this.categories.length) {
                            this.categories = [event.target.dataset.id];
                        }
                    // reset other sub terms on term change
                    } else {
                        if (this.categories.length > 2) {
                            this.categories = [event.target.dataset.id, event.target.dataset.anc];
                        }
                    }

                    this.setActiveFilters();
                    this.filterItems();
                    this.prepareAnalytics();
                },

                isActive (termId, filter)
                {
                    return (typeof this.activeFilters[filter] === 'object' && this.activeFilters[filter].includes(termId)) ? 'active' : '';
                },

                sortItems ()
                {
                    this.toggleBusy(false);
                    if (typeof this.orderByConfig[this.orderBy] === 'object') {
                        const config = this.orderByConfig[this.orderBy];
                        const attr = config.orderby;

                        if (config.order==='ASC') {
                            this.filteredItems.sort((a, b) => (a[attr] > b[attr]) ? 1 : -1)
                        } else {
                            this.filteredItems.sort((a, b) => (a[attr] < b[attr]) ? 1 : -1)
                        }
                    }

                    this.updateHistory();
                    this.updatePublicItems();

                    setTimeout(this.toggleBusy, 500);
                },

                prepareAnalytics()
                {
                    // _log('prepareAnalytics');
                    this.analytics['colors'] = [];
                    this.analytics['materials'] = [];
                    this.analytics['categories'] = [];

                    for (let i =0; i<this.items.length; i++) {
                        let item = this.items[i];

                        if (item.categoryIds.length) {
                            for (let c=0; c<item.categoryIds.length; c++) {
                                let categoryId = item.categoryIds[c];
                                if (typeof this.analytics['categories'][categoryId] === 'undefined') {
                                    this.analytics['categories'][categoryId] = 1;
                                } else {
                                    this.analytics['categories'][categoryId] ++;
                                }
                            }
                        }

                        // only count colors of current term
                        // if (!item.categoryIds.includes(this.activeFilters.term_id)) {
                        //     continue;
                        // }
                        const requiredTerms = (this.activeFilters.categories.length) ?
                                                this.activeFilters.categories :
                                                [this.activeFilters.term_id];

                        if (!this.hasRequiredElements(item.categoryIds, requiredTerms) && !this.isShopPage) {
                            continue;
                        }

                        const paAttributes = {
                            paMaterialIds : 'materials',
                            paColorIds : 'colors',
                        };

                        for (let attr in paAttributes) {
                            let anIndex = paAttributes[attr];

                            if (item[attr].length) {
                                for (let c=0; c<item[attr].length; c++) {
                                    let termId = item[attr][c];

                                    let isValid = true;
                                    if (attr === 'paColorIds' && this.activeFilters.materials.length) {
                                        if (!this.findCommonElements3(item.paMaterialIds, this.activeFilters.materials)) {
                                            isValid = false;
                                        }
                                    } else if (attr === 'paMaterialIds' && this.activeFilters.colors.length) {
                                        if (!this.findCommonElements3(item.paColorIds, this.activeFilters.colors)) {
                                            isValid = false;
                                        }
                                    }

                                    if (isValid) {
                                        if (typeof this.analytics[anIndex][termId] === 'undefined') {
                                            this.analytics[anIndex][termId] = 0;
                                        }

                                        this.analytics[anIndex][termId] ++;
                                    }
                                }
                            }
                        }
                    }
                },

                getAnalyticsCount(id, attr)
                {
                    if (typeof this.analytics[attr][id] !== 'undefined') {
                        return this.analytics[attr][id];
                    } else {
                        return 0;
                    }
                },

                toggleMobileWidget (elementId)
                {
                    const element = document.getElementById(elementId);
                    element.classList.toggle('active');

                    if (!element.classList.contains('active')) {
                        document.getElementById('breadcrumb').scrollIntoView({block: "end", behavior: "smooth"});
                    }
                },

                toggleFilterList (elementId)
                {
                    document.getElementById(elementId).classList.toggle('active');
                },

                filterByTextSearch (event)
                {
                    // event.preventDefault();

                    /* text searach temporarily disabled */
                    // const textQuery = this.textSearch.trim();

                    // // filter items only if text query 0 (reset) or has min 3 chars
                    // if (textQuery.length === 0 || textQuery.length >=3) {
                    //     this.filterItems();
                    // }
                },

                setActiveFilters()
                {
                    // set values
                    this.colors     = (typeof this.colors === 'string') ? [this.colors] : this.colors;
                    this.materials  = (typeof this.materials === 'string') ? [this.materials] : this.materials;
                    this.categories  = (typeof this.categories === 'string') ? [this.categories] : this.categories;

                    // set active filters
                    // default filters
                    this.activeFilters.textSearch   = this.textSearch.trim().toLowerCase();
                    this.activeFilters.colors       = this.colors.map(termId => parseInt(termId));
                    this.activeFilters.materials    = this.materials.map(termId => parseInt(termId));

                    // categories only used on product tag pages
                    this.activeFilters.categories   = this.categories.map(termId => parseInt(termId));

                    this.activeFilters.term_id      = this.term_id;
                    this.activeFilters.orderBy      = this.orderBy;

                    this.setCountFilters();

                    return this.activeFilters;
                },

                resetFilters ()
                {
                    this.categories = this.materials = this.colors = []
                    this.filterItems();
                },

                setCountFilters ()
                {
                    this.countFilters = 0;

                    const attr = ['materials', 'colors', 'categories'];
                    for (let i=0; i < attr.length; i++) {
                        let filter = attr[i];
                        if (this.activeFilters[filter]) {
                            this.countFilters += (typeof this.activeFilters[filter] === 'string') ? 1 : this.activeFilters[filter].length;
                        }
                    }
                },

                filterItems ()
                {
                    this.filteredItems = [];
                    const filters = this.setActiveFilters();
                    this.filteredItems = this.items.filter(this.passedFilters)
                    this.sortItems();
                },

                passedFilters(item)
                {
                    let isValid = true;

                    if (this.activeFilters.textSearch) {
                        let titleMatch = (item.title.toLowerCase().search(this.activeFilters.textSearch) === -1) ? false : true;

                        if (!titleMatch) {
                            isValid = false;
                        }

                        // only check variationName if exists
                        if (item.variationName && item.variationName.length) {
                            if (item.variationName.toLowerCase().search(this.activeFilters.textSearch) !== -1) {
                                isValid = true;
                            }
                        }
                    }

                    if (this.activeFilters.term_id) {
                        if (!item.categoryIds.includes(this.activeFilters.term_id)) {
                            isValid = false;
                        }
                    }

                    if (this.activeFilters.categories.length) {
                        if (!this.hasRequiredElements(item.categoryIds, this.activeFilters.categories)) {
                            isValid = false;
                        }
                    }

                    if (this.activeFilters.colors.length) {
                        if (!this.findCommonElements3(item.paColorIds, this.activeFilters.colors)) {
                            isValid = false;
                        }
                    }

                    if (this.activeFilters.materials.length) {
                        if (!this.findCommonElements3(item.paMaterialIds, this.activeFilters.materials)) {
                            isValid = false;
                        }
                    }

                    return isValid;
                },

                findCommonElements3(array1, array2)
                {
                   return array1.some(item => array2.includes(item));
                },

                hasRequiredElements(termIds, required)
                {
                    return required.every(elem => termIds.includes(elem))
                },

                updatePublicItems()
                {
                    // how many items are currently visible ?
                    let visibleIems = 0;
                    if (typeof this.publicItems === "object" && this.publicItems) {
                       visibleIems = this.publicItems.length;
                    }

                    this.setPublicItems(visibleIems);
                },

                setPublicItems(visibleIems)
                {
                    const ppp = 12;
                    const def = ppp;
                    let diff = ppp;

                    // what is the difference between the filtered items and visible items ?
                    if (typeof this.filteredItems === "object" && this.filteredItems.length) {
                        diff = this.filteredItems.length - visibleIems;
                    }

                    const count = (diff >= def) ? ppp : diff;

                    if (this.filteredItems.length) {
                        this.publicItems = this.filteredItems.slice(0, (visibleIems+count));
                    } else {
                        this.publicItems = [];
                    }
                },

                addToCart (item)
                {
                    this.productId = item.id;
                    this.setStatusClass(this.productId, 'busy');
                    this.removeStatusClass(this.productId, 'added');
                    wcRest.addToCart(this.productId, 1, this.addToCart__callbackSuccess, this.addToCart__callbackError);
                },

                setStatusClass( productId, className )
                {
                    document.getElementById('item-'+productId).classList.add(className);
                },

                removeStatusClass( productId, className )
                {
                    document.getElementById('item-'+productId).classList.remove(className);
                },

                addToCart__callbackSuccess(response)
                {
                    window['header'].updateCart();

                    this.setStatusClass(this.productId, 'added');
                    this.removeStatusClass(this.productId, 'busy');
                    this.productId = null;
                },

                addToCart__callbackError(error)
                {
                    _log("addToCart__callbackError");
                    // this.xhrStatus = '';
                    _log(error);
                    _log(error.response);
                    if (error.response) {
                        _log(error.response.data.message);
                        this.xhrMessage = error.response.data.message.replaceAll('&quot;', "'");
                    }
                    this.removeStatusClass(this.productId, 'busy');
                },

                mabyeShowColors()
                {
                    if (window.innerWidth <= 1198 || window.outerWidth <= 1198) {
                        this.toggleFilterList('js_colorFilters');
                        this.toggleFilterList('js_materialFilters');
                    }
                },

                init()
                {
                    this.filterItems();
                    this.prepareAnalytics();
                    this.mabyeShowColors();
                    document.getElementById('taxonomy').classList.add('isReady');
                    this.restoreScrollPosition();
                },

                getItems()
                {
                    // const storage = this.getStorage('items');

                    // // check if objects are in local storage
                    // if (storage && typeof storage === 'object') {
                    //     // todo check timeout
                    //     if (typeof storage.items === 'object' && storage.items.length && storage.termid == this.parentTermId) {
                    //         const now = new Date();
                    //         const diff = now.getTime()-storage.time;

                    //         // if difference less than 600s or 60.0000 ms (10 minutes)
                    //         // then load storage
                    //         if (diff <= (600*1000)) {
                    //             this.items = storage.items;
                    //             this.subTerms = storage.subTerms;
                    //             this.init();
                    //         }
                    //     }
                    // }

                    // load from json-file if items are empty
                    if (this.items.length === 0) {
                        let queryString = "";
                        const queryArgs = {
                            action : 'get_products',
                            term_id : this.parentTermId,
                            taxonomy : this.taxonomy
                        };

                        for (var i in queryArgs) {
                            queryString += i + "=" + queryArgs[i]+"&";
                        }
                        const url = xhrUrl + "?" + queryString;

                        axios.get(url).then(this.getItems__callback);
                    }
                },

                getItems__callback(response)
                {
                    if (typeof response === 'object' && typeof response.data === 'object') {
                        this.items = response.data.items;
                        this.subTerms = response.data.subTerms;
                        this.subTermsMobile = this.flattenSubTerms(response.data.subTerms);
                        this.init();

                        // update storage
                        const date = new Date();

                        // const data = {
                        //     termid : this.parentTermId,
                        //     items : this.items,
                        //     subTerms : this.subTerms,
                        //     time : date.getTime()
                        // };
                        // this.setStorage('items', data);
                    }
                },

                flattenSubTerms(terms)
                {
                    var newTerms  = [];
                    for (let i=0; i<terms.length; i++) {
                        newTerms.push(terms[i]);
                        if (typeof terms[i].subTerms === 'object' && terms[i].subTerms.length) {
                            newTerms = [...newTerms, ...terms[i].subTerms];
                        }
                    }

                    return newTerms;
                },

                maybePrefixName(term)
                {
                    return (term.parent && term.parent != this.parentTermId) ? ' - '+term.name : term.name;
                },

                updateHistory()
                {
                    const args = this.activeFilters;

                    const queryString = httpHuildQuery(args);
                    if (queryString) {
                        const stateData = {
                            path: window.location.href,
                            scrollTop: window.scrollY
                        };

                        window.history.replaceState(stateData, 'NomaNorge', queryString);
                    }
                },

                updateScrollPosition()
                {
                    const now = new Date();
                    const storage = {
                        y : window.scrollY,
                        v : this.publicItems.length,
                        time : now.getTime()
                    };

                    this.setStorage('term-'+this.parentTermId, storage);
                },

                getScrollPosition()
                {
                    const storage = this.getStorage('term-'+this.parentTermId);

                    let position = null;
                    if (storage && typeof storage === 'object') {

                        if (typeof storage.y !== 'undefined' && !isNaN(storage.y)) {
                            const now = new Date();
                            const diff = now.getTime()-storage.time;

                            // if difference less than 60s or 60.000 ms
                            // then load storage
                            if (diff <= (60*1000)) {
                                position = storage;
                            }
                        }
                    }

                    return position;
                },

                restoreScrollPosition()
                {
                    const position = this.getScrollPosition();

                    if (position) {
                        this.setPublicItems(position.v);
                        setTimeout(function(){
                            window.scrollTo(0, position.y)
                        }, 1500);
                    }
                },

                setStorage(key, data)
                {
                    const cache = JSON.stringify(data);
                    localStorage.setItem(key, cache);
                },

                getStorage(key)
                {
                    const storage = localStorage.getItem(key);

                    let json = null;
                    if (typeof storage === 'string') {
                        json = JSON.parse(storage);
                    }

                    return json;
                },

            }, // methods

            created ()
            {
                window.history.scrollRestoration = 'manual';
                this.getItems();

                window.addEventListener("scroll", this.initWindowScroll);
            }
      });

    }

} // end of class